import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListView } from '../core/ListViewProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { SignAsoColumns } from './columns/_columns'
import { AtendimentoList } from '../../../atendimento/core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { IconPaths } from '../../../../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'

export const SignAsoTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { selected } = useListView()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => SignAsoColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhum ASO encontrado'
      description='Revise o paciente, o protocolo ou o estado selecionado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      icon={IconPaths.Check}
      title='Nenhum ASO pendente de assinatura'
      description='Os ASOs sob sua responsabilidade aparecem aqui quando estiverem prontos para assinar.'
    />
  )

  return (
    <CustomTable<AtendimentoList>
      id='kt_table_sign_aso'
      ariaLabel='ASOs para assinar'
      itemLabel={{ singular: 'ASO', plural: 'ASOs' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      isRowSelected={(row) => selected.includes(row.id)}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
